<template>
  <transition name="fade">
    <div class="componens" v-show="show">
      <div class="w3-row">
        <div class="w3-twothird">
          <div class="text-container">
            Ez az oldal sütiket használ a felhasználói élmény fokozása érdekében.
            <router-link v-if="!isLandingPage" class="cookie-bar-prompt-button" to="/adatvedelmi-nyilatkozat">Részletek</router-link>
          </div>
        </div>
        <div class="w3-third button-container">
          <button
            class="w3-button w3-pink"
            @click="setCookie('acceptedCookies', 'true', 365)"
          >
            Sütik elfogadása
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'cookieBar',
    data() {
      return {
        show: false,
      };
    },
    mounted() {
      if (!document.cookie.includes('acceptedCookies=true')) {
        this.show = true;
      }
    },
    methods: {
      setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = `expires=${d.toUTCString()}`;
        document.cookie = `${cname}=${cvalue}; ${expires};path=/`;
        this.show = false;
      },
    },
    computed: {
      isLandingPage() {
        return this.$route.name === 'LandingPage';
      },
    },
  };

</script>


<style scoped>
  .w3-row {
    margin-left: 10px;
    margin-right: 10px;
  }

  .componens {
    z-index: 3;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, .85);
    font-size: 14px;
    padding: 5px 5px 0 5px;
  }

  .cookie-bar-prompt-button {
    padding-left: 20px;
  }

  .text-container {
    color: white;
    height: inherit;
    display: table-cell;
    vertical-align: middle;
    height: 40px;
  }

  .button-container {
    text-align: right;
  }

  button {
    opacity: 1;
    width: 200px;
    background-color: #eb2e4a !important;
  }

  @media (max-width: 902px) {
    .text-container {
      text-align: center;
    }

    .button-container {
      text-align: center;
    }

  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

</style>



// WEBPACK FOOTER //
// CookieBar.vue?1acab91c